import * as TypeGraphQL from "type-graphql";
export var InstitutionalSentimentAlertsScalarFieldEnum;
(function (InstitutionalSentimentAlertsScalarFieldEnum) {
    InstitutionalSentimentAlertsScalarFieldEnum["id"] = "id";
    InstitutionalSentimentAlertsScalarFieldEnum["timestamp"] = "timestamp";
    InstitutionalSentimentAlertsScalarFieldEnum["type"] = "type";
    InstitutionalSentimentAlertsScalarFieldEnum["errorRate"] = "errorRate";
    InstitutionalSentimentAlertsScalarFieldEnum["totalRecords"] = "totalRecords";
    InstitutionalSentimentAlertsScalarFieldEnum["errorCount"] = "errorCount";
    InstitutionalSentimentAlertsScalarFieldEnum["severity"] = "severity";
    InstitutionalSentimentAlertsScalarFieldEnum["resolved"] = "resolved";
    InstitutionalSentimentAlertsScalarFieldEnum["resolvedAt"] = "resolvedAt";
    InstitutionalSentimentAlertsScalarFieldEnum["resolvedBy"] = "resolvedBy";
    InstitutionalSentimentAlertsScalarFieldEnum["createdAt"] = "createdAt";
    InstitutionalSentimentAlertsScalarFieldEnum["updatedAt"] = "updatedAt";
})(InstitutionalSentimentAlertsScalarFieldEnum || (InstitutionalSentimentAlertsScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(InstitutionalSentimentAlertsScalarFieldEnum, {
    name: "InstitutionalSentimentAlertsScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=InstitutionalSentimentAlertsScalarFieldEnum.js.map